import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Pill from '@components/Pill';

const messages = defineMessages({
  selfReported: {
    id: 'GLOBAL.selfReported',
    defaultMessage: 'Self-Reported',
  },
});

export default function SelfReportedPill({ header = false, value = false }) {
  const { formatMessage } = useIntl();
  if (!value) {
    return null;
  }

  return (
    <Pill
      color="secondary"
      header={header}
      label={formatMessage(messages.selfReported)}
      size="small"
    />
  );
}
